import { render, staticRenderFns } from "./CardTimeoutChatbot.vue?vue&type=template&id=7dd90496&scoped=true&"
import script from "./CardTimeoutChatbot.vue?vue&type=script&lang=js&"
export * from "./CardTimeoutChatbot.vue?vue&type=script&lang=js&"
import style0 from "./CardTimeoutChatbot.vue?vue&type=style&index=0&id=7dd90496&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dd90496",
  null
  
)

export default component.exports